import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import fotaViewTypeEnum, {
  ModuleToOpen,
} from "../../constants/fota-view-type-enum";
import systemModuleEnum from "../../constants/system-module-enum";
import { useStore } from "../../contexts/StoreProvider";
import { isOperationPermitted } from "../../helpers/action-permission-helper";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import { formatMessage } from "../../translations/format-message";
import "./fota-mzl-release.css";
import IPageInfo from "../../models/ICommon";
import _ from "lodash";

import FotaMzlReleaseView from "./fota-mzl-release-view";

const FotaMzlRelease = (props: any) => {
  const { fotaMzlReleaseStore } = useStore();
  const {
    error,
    inProgress,
    reset,
    setSelectedView,
    isSelectedView,
    setIsAddUpdatePopupOpen,
  } = fotaMzlReleaseStore;

  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const fotaViewToggleHandler = (viewType: fotaViewTypeEnum) => {
    setSelectedView({ ...isSelectedView, view: viewType, isViewChanged: true });
  };


  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    return (() => {
      // setSelectedView({view: (getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? fotaViewTypeEnum.Modem : fotaViewTypeEnum.Host), moduleToOpen: ModuleToOpen.Schedule, isViewChanged: false})
      //Deepak [13-Aug-25]
      setSelectedView({ view: fotaViewTypeEnum.Modem, moduleToOpen: ModuleToOpen.Config, isViewChanged: false })
    })
  }, []);

  const closePanelHandler = () => {
    //resetFotaHostConfigState();
    setOpenPanel(false);
    setSelectedRow({});
    setSelectedId(-1);
  };

  const openAddPopupHandler = () => {
    closePanelHandler();
    setSelectedId(-1);
    setIsAddUpdatePopupOpen(true);
  };

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area">
                  <ul className="d-flex align-items-center">
                    <li className="fotaTabs-switch">
                      <button
                        className={`modem ${isSelectedView.view === fotaViewTypeEnum.Modem
                          ? "active"
                          : ""
                          }`}
                        type="button"
                        onClick={
                          isSelectedView.view !== fotaViewTypeEnum.Modem
                            ? () => {
                              closePanelHandler();
                              fotaViewToggleHandler(fotaViewTypeEnum.Modem);
                            }
                            : () => { }
                        }
                      >
                        <svg
                          id="Layer_1"
                          fill="currentColor"
                          enableBackground="new 0 0 512 512"
                          height="18px"
                          viewBox="0 0 512 512"
                          width="18px"
                          className="me-1"
                        >
                          <g id="XMLID_493_">
                            <path
                              id="XMLID_582_"
                              d="M66.707,93.022c-2.006-8.037-10.146-12.921-18.187-10.92c-8.038,2.007-12.926,10.149-10.919,18.188   l35.857,143.613h30.921L66.707,93.022z"
                            />
                            <path
                              id="XMLID_584_"
                              d="M454.5,244.043l35.892-143.754c2.007-8.038-2.882-16.181-10.919-18.188   c-8.04-2.004-16.18,2.882-18.187,10.92l-37.672,150.881H449.5C451.178,243.903,452.845,243.952,454.5,244.043z"
                            />
                            <path
                              id="XMLID_598_"
                              d="M449.5,273.903h-389c-33.36,0-60.5,27.141-60.5,60.5v64.444c0,16.267,13.234,29.5,29.5,29.5h451   c16.266,0,29.5-13.233,29.5-29.5v-64.444C510,301.044,482.86,273.903,449.5,273.903z M87.223,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S95.507,367.676,87.223,367.676z M131.667,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S139.951,367.676,131.667,367.676z M176.112,367.676h-0.556   c-8.284,0-15-6.716-15-15s6.716-15,15-15h0.556c8.284,0,15,6.716,15,15S184.396,367.676,176.112,367.676z M414.928,367.676h-64.373   c-8.284,0-15-6.716-15-15s6.716-15,15-15h64.373c8.284,0,15,6.716,15,15S423.212,367.676,414.928,367.676z"
                            />
                          </g>
                        </svg>
                        <FormattedMessage id="modem" />
                      </button>
                      <button
                        className={`modem ${isSelectedView.view === fotaViewTypeEnum.Jet
                          ? "active"
                          : ""
                          }`}
                        type="button"

                        onClick={
                          isSelectedView.view !== fotaViewTypeEnum.Jet
                            ? () => {
                              closePanelHandler();
                              fotaViewToggleHandler(fotaViewTypeEnum.Jet);
                            }
                            : () => { }
                        }
                      >
                        <svg
                          className="me-1"
                          fill="currentColor"
                          height="18px"
                          width="18px"
                          viewBox="0 0 512 512"
                          role="img"
                        >
                          <g>
                            <circle cx="391.5" cy="288.655" r="18.734" />
                            <path d="m512 202.407h-209.638c-6.342 19.553-24.723 33.734-46.362 33.734-26.872 0-48.734-21.862-48.734-48.734 0-21.639 14.181-40.02 33.734-46.362v-141.045h-105.5v176.983c19.553 6.342 33.734 24.723 33.734 46.362 0 26.872-21.862 48.734-48.734 48.734s-48.734-21.862-48.734-48.734c0-21.639 14.181-40.02 33.734-46.362v-176.983h-105.5v309.593h209.638c6.342-19.553 24.723-33.734 46.362-33.734 26.872 0 48.734 21.862 48.734 48.734 0 21.639-14.181 40.02-33.734 46.362v141.045h105.5v-176.983c-19.553-6.342-33.734-24.723-33.734-46.362 0-26.872 21.862-48.734 48.734-48.734s48.734 21.862 48.734 48.734c0 21.639-14.181 40.02-33.734 46.362v176.983h105.5z" />
                            <path d="m338.514 86.203c0 10.331 8.404 18.735 18.734 18.735s18.734-8.404 18.734-18.735c0-10.33-8.404-18.734-18.734-18.734s-18.734 8.404-18.734 18.734z" />
                            <path d="m271 141.045c14.825 4.808 26.554 16.537 31.362 31.362h209.638v-71.204h-108.39c-6.342 19.554-24.723 33.735-46.362 33.735-26.872 0-48.734-21.862-48.734-48.735 0-26.872 21.862-48.734 48.734-48.734 21.639 0 40.02 14.181 46.362 33.734h108.39v-71.203h-241z" />
                            <path d="m241 370.955c-14.825-4.808-26.554-16.537-31.362-31.362h-209.638v71.204h108.389c6.342-19.554 24.723-33.735 46.363-33.735 26.872 0 48.734 21.862 48.734 48.735 0 26.872-21.862 48.734-48.734 48.734-21.64 0-40.021-14.181-46.363-33.734h-108.389v71.203h241z" />
                            <circle cx="120.5" cy="223.345" r="18.734" />
                            <circle cx="256" cy="187.407" r="18.734" />
                            <path d="m173.486 425.797c0-10.331-8.404-18.735-18.734-18.735-10.331 0-18.735 8.404-18.735 18.735 0 10.33 8.404 18.734 18.735 18.734 10.33 0 18.734-8.404 18.734-18.734z" />
                            <circle cx="256" cy="324.593" r="18.734" />
                          </g>
                        </svg>
                        <FormattedMessage id="jet" />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    {isOperationPermitted(systemModuleEnum.Fota, "Add") &&
                      (
                        <li title={formatMessage("add")}>
                          <LoaderButton
                            id="fotaUpdateModal"
                            text="add"
                            onClick={() => openAddPopupHandler()}
                          />
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FotaMzlReleaseView
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        openPanel={openPanel}
        setOpenPanel={setOpenPanel}
        closePanelHandler={closePanelHandler}
        pageInfo={pageInfo}
        setPageInfo={setPageInfo}
      />
    </>
  );
};

export default observer(FotaMzlRelease);
